
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5535',
  depVersions: {
  "data-privacy-request-ui": "static-1.5535",
  "data-fetching-client": "static-1.9678",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8024",
  "hub-http-shared-msw-handlers": "static-1.9988",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11481",
  "I18n": "static-7.1628",
  "jasmine-runner": "static-1.6474",
  "privacy-center-public-service-types": "static-1.4798",
  "quartz": "static-1.7046",
  "react-dlb": "static-1.79",
  "ui-components-test-utils": "static-1.5618",
  "UIComponents": "static-3.8427",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.86",
  "foundations-assets": "static-1.4876",
  "foundations-components": "static-1.7958",
  "foundations-components-test-utils": "static-1.5441",
  "foundations-theming": "static-1.4428",
  "hub-http": "static-1.6231",
  "quartz-config": "static-1.824",
  "quartz-core": "static-1.6265",
  "quartz-routing": "static-1.476",
  "quick-fetch": "static-1.3922",
  "raven": "static-3.5925",
  "react": "static-7.186",
  "react-rhumb": "static-1.16682",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11158",
  "usage-tracker": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-anonymous": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3405",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3323",
  "quartz-webpack": "static-1.3270",
  "bend-plugin-quartz-routing": "static-1.124",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "HeadJS": "static-2.762",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3135",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "ts-schema": "static-1.4085",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "react-utils": "static-2.5350",
  "StyleGuideUI": "static-3.487",
  "jasmine": "static-4.4337",
  "rpc-client-utils": "static-1.4662",
  "HubStyle": "static-2.11788",
  "ui-addon-draggable": "static-3.4772",
  "cssUtils": "static-1.794",
  "hs-story-utils": "static-1.9434",
  "icons": "static-2.648",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "ui-images": "static-2.1156",
  "bend-plugin-foundations-components": "static-1.4227",
  "floating-ui": "static-1.56",
  "foundations-theming-specialty": "static-1.2144",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1977",
  "ui-fonts": "static-1.743",
  "foundations-components-legacy": "static-1.983",
  "bend-plugin-foundations-theming": "static-1.2911",
  "foundations-theming-base": "static-1.3413",
  "stylex": "static-1.33",
  "hs-locale-management": "static-1.87",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.836",
  "hubspotter-http": "static-1.4657",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.721",
  "quartz-head": "static-1.711",
  "quartz-i18n": "static-1.721",
  "quartz-test": "static-1.721",
  "quartz-tracking": "static-1.425",
  "usage-tracker-container": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "csstype": "static-1.50",
  "web-vitals": "static-1.6",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3205",
  "bend-plugin-chirp-manifest": "static-1.72",
  "chirp-fetch": "static-1.1897",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.70",
  "sassPrefix": "static-1.156",
  "hubspotter-http-shared-msw-handlers": "static-1.9986",
  "usage-tracker-session-replay": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5535",
  "data-fetching-client": "/data-fetching-client/static-1.9678",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8024",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9988",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11481",
  "I18n": "/I18n/static-7.1628",
  "jasmine-runner": "/jasmine-runner/static-1.6474",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4798",
  "quartz": "/quartz/static-1.7046",
  "react-dlb": "/react-dlb/static-1.79",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5618",
  "UIComponents": "/UIComponents/static-3.8427",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "foundations-assets": "/foundations-assets/static-1.4876",
  "foundations-components": "/foundations-components/static-1.7958",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5441",
  "foundations-theming": "/foundations-theming/static-1.4428",
  "hub-http": "/hub-http/static-1.6231",
  "quartz-config": "/quartz-config/static-1.824",
  "quartz-core": "/quartz-core/static-1.6265",
  "quartz-routing": "/quartz-routing/static-1.476",
  "quick-fetch": "/quick-fetch/static-1.3922",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.186",
  "react-rhumb": "/react-rhumb/static-1.16682",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11158",
  "usage-tracker": "/usage-tracker/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "/usage-tracker-core/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3405",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3323",
  "quartz-webpack": "/quartz-webpack/static-1.3270",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.124",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "HeadJS": "/HeadJS/static-2.762",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3135",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "ts-schema": "/ts-schema/static-1.4085",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "react-utils": "/react-utils/static-2.5350",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "jasmine": "/jasmine/static-4.4337",
  "rpc-client-utils": "/rpc-client-utils/static-1.4662",
  "HubStyle": "/HubStyle/static-2.11788",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4772",
  "cssUtils": "/cssUtils/static-1.794",
  "hs-story-utils": "/hs-story-utils/static-1.9434",
  "icons": "/icons/static-2.648",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "ui-images": "/ui-images/static-2.1156",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4227",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2144",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1977",
  "ui-fonts": "/ui-fonts/static-1.743",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.983",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2911",
  "foundations-theming-base": "/foundations-theming-base/static-1.3413",
  "stylex": "/stylex/static-1.33",
  "hs-locale-management": "/hs-locale-management/static-1.87",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "hubspotter-http": "/hubspotter-http/static-1.4657",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.721",
  "quartz-head": "/quartz-head/static-1.711",
  "quartz-i18n": "/quartz-i18n/static-1.721",
  "quartz-test": "/quartz-test/static-1.721",
  "quartz-tracking": "/quartz-tracking/static-1.425",
  "usage-tracker-container": "/usage-tracker-container/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.6",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3205",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.72",
  "chirp-fetch": "/chirp-fetch/static-1.1897",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.70",
  "sassPrefix": "/sassPrefix/static-1.156",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9986",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
